import { FlowParameterEventFieldsFragment } from '~/graphql/types';
import { AppFundaBrochureRequestPointerParameterValue } from '~/scenes/Automation/Flows/Actions/Base/types.flow';
import { assertNever } from '~/util/assertion';
import cleanedFilename from '~/util/cleanedFilename';

import { PARAMETER_VALUE_TYPE } from '../../../constants';
import emptyFundaBrochureRequestEventParameterValue from './emptyFundaBrochureRequestEventParameterValue';

export default (
  eventFundaBrochureRequestParameter:
    | Extract<
        FlowParameterEventFieldsFragment,
        {
          __typename: 'Flow_Parameter_Event_Contact_App_Funda_BrochureRequest_Pointer';
        }
      >
    | null
    | undefined,
): AppFundaBrochureRequestPointerParameterValue => {
  if (eventFundaBrochureRequestParameter == null) {
    return emptyFundaBrochureRequestEventParameterValue();
  }
  switch (eventFundaBrochureRequestParameter.__typename) {
    case 'Flow_Parameter_Event_Contact_App_Funda_BrochureRequest_Pointer':
      return {
        type: PARAMETER_VALUE_TYPE.EVENT_CONTACT_APP_FUNDA_BROCHUREREQUEST_POINTER,
        variable: {
          name: eventFundaBrochureRequestParameter.variable,
          field: eventFundaBrochureRequestParameter.field
            ? {
                name: eventFundaBrochureRequestParameter.field,
              }
            : null,
        },
      };

    default:
      return assertNever(
        eventFundaBrochureRequestParameter.__typename,
        cleanedFilename(__filename),
      );
  }
};
